import { createSelector } from '@ngrx/store';

import { loaderSelector } from '../core.state';
import { LoaderState } from './loader.reducer';

export const isLoadingSpinnerActive = createSelector(
    loaderSelector,
    (state: LoaderState) => state.active > 0
);
